import { Card } from "@/components/ui/card";
import { Plus } from "lucide-react";

export type NewRecipeBoxTileProps = Readonly<{
  onClick: () => void;
  disabled?: boolean;
}>;

export const NewRecipeBoxTile = ({ onClick, disabled = false }: NewRecipeBoxTileProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label="Create a new recipe box"
      className="group hidden h-full w-full rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed sm:block"
    >
      <Card className="flex h-full flex-col border border-dashed border-muted-foreground/40 bg-card text-muted-foreground transition hover:border-muted-foreground hover:text-foreground hover:shadow-md">
        <div className="flex aspect-square items-center justify-center">
          <Plus className="h-8 w-8 transition group-hover:scale-105" strokeWidth={1.5} />
        </div>
        <div className="p-1.5 text-center">
          <span className="font-headline text-sm font-medium">New Recipe Box</span>
        </div>
      </Card>
    </button>
  );
};

